var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiverPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.826 3.01a4.583 4.583 0 1 0 6.482 6.48 4.583 4.583 0 0 0-6.482-6.48Zm5.266 1.214a2.865 2.865 0 1 1-4.05 4.052 2.865 2.865 0 0 1 4.05-4.052Zm4.627 12.291c.342.936-.445 1.818-1.442 1.818H4.857c-.998 0-1.785-.882-1.442-1.818 1.039-2.838 3.625-4.848 6.652-4.848s5.613 2.01 6.652 4.848Zm-6.652-3.098c2.03 0 3.867 1.241 4.784 3.166H5.282c.918-1.925 2.754-3.166 4.785-3.166Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiverPersonal);
export default __webpack_public_path__ + "static/media/receiver_personal.1591a6af6be6231ae88d4582fc054df0.svg";
export { ForwardRef as ReactComponent };